import { Injectable } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

import { HubConfigRolesSettingsComponent } from '@main-client/src/app/hub-configuration/hub-config-roles/hub-config-roles-settings/hub-config-roles-settings.component';

import { Group } from '@libs/src/models/group.model';

@Injectable()
export class HubConfigRolesSettingsService {
  constructor(private readonly drawer: NzDrawerService) {}

  openDrawer(group: Group) {
    return this.drawer.create({
      nzBodyStyle: { padding: 0 },
      nzContent: HubConfigRolesSettingsComponent,
      nzData: { group },
      nzTitle: $localize`:@@hubConfigRolesSettings.drawerTitle:Role settings`,
      nzWidth: '600px',
    });
  }
}
